import { createStore, SetState } from '@oneappexchange/lwc-wired';
import { State } from 'zustand';
import { SiteConfig, SiteDomain } from '~/modules/appx_site_schema';

export interface SiteConfigState extends State {
    domain: SiteDomain;
    isAgentExchange: boolean;
    isAppExchange: boolean;
}

const initialState: SiteConfigState = {
    domain: 'appexchange',
    isAgentExchange: false,
    isAppExchange: true,
};

export const siteConfigStore = createStore(initialState, (set: SetState<SiteConfigState>) => ({
    initialize(config: SiteConfig) {
        set((draft) => {
            draft.domain = config.domain;
            draft.isAgentExchange = config.domain === 'agentexchange';
            draft.isAppExchange = config.domain === 'appexchange';
        });
    },
}));

export function selectIsAgentExchange(state: SiteConfigState): boolean {
    return state.isAgentExchange;
}

export function selectDomain(state: SiteConfigState): SiteDomain {
    return state.domain;
}
